// Shared constants for the Online Lecture panel.
// Values are backend contracts — do not change without backend confirmation.

export const UrlType = {
    None: 0,
    Youtube: 1,
    WebView: 2,
    VideoPlayer: 3,
};

export const URL_TYPE_OPTIONS = Object.keys(UrlType).map((key) => ({
    label: key,
    value: UrlType[key],
}));

// ClassTypes rendered from the getsegments response (only these two are shown)
export const CLASS_TYPE_YKS = 90;
export const CLASS_TYPE_LGS = 91;

// ExamCategoryId radio values sent to the backend (unchanged legacy contract)
export const EXAM_CATEGORY_ID_BY_CLASS_TYPE = {
    [CLASS_TYPE_YKS]: 1,
    [CLASS_TYPE_LGS]: 2,
};

// Mutual (Rehberlik / ortak) lectures keep their hardcoded ExamType values
export const MUTUAL_EXAM_TYPE_OPTIONS = {
    1: { value: 99, label: "TYT-AYT" }, // YKS radio
    2: { value: 3, label: "LGS" },      // LGS radio
};

// Synthetic teacher option for multi-teacher mutual lectures (value 0 is a backend contract)
export const PAKODEMY_TEACHER_OPTION = {
    Id: 0,
    TeacherName: "Pakodemy Hoca(birden çok Hoca varsa)",
    ImageUrl: null,
};

export const HOMEWORK_TYPE_OPTIONS = [
    { value: "", label: "Ödev Türü Seçiniz", disabled: false },
    { value: "PDF", label: "PDF", disabled: false },
    { value: "Serbest Soru Çözümü", label: "Serbest Soru Çözümü", disabled: false },
    { value: "Öğretmen Videosu", label: "Öğretmen Videosu", disabled: true },
    { value: "Ders Videosu", label: "Ders Videosu", disabled: true },
    { value: "Ders Konu Kartı", label: "Ders Konu Kartı", disabled: true },
];

export const QUESTION_COUNT_MIN = 1;
export const QUESTION_COUNT_MAX = 120;

// Sticky default for the UrlType select in the add forms (legacy key, keep as-is)
export const URL_TYPE_STORAGE_KEY = "selectedUrlTypeValue";

// PDF upload status messages. PDF_MSG_SUCCESS doubles as the submit gate
// condition in the add flows (legacy behavior) — the wording is load-bearing.
export const PDF_MSG_UPLOADING = "PDF dosyanız yükleniyor Lütfen Bekleyiniz";
export const PDF_MSG_RENAMING = "PDF Dosyası Güncelleniyor lütfen bekleyiniz";
export const PDF_MSG_SUCCESS = "PDF yükleme başarılı";
export const PDF_MSG_FAILED = "Pdf dosyası yüklenemedi";
export const PDF_MSG_REQUIRED = "Lütfen Pdf Yükleyiniz!";

export const CONTENT_PROCESS_UPLOAD_URL =
    "https://contentprocess.tosanalytics.com/api/Mediafile/uploads";
export const CONTENT_PROCESS_RENAME_URL =
    "https://contentprocess.tosanalytics.com/api/mediafile/renamefile";
